var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pageCount > 1)?_c('v-pagination',{attrs:{"color":"accent","length":_vm.pageCount},model:{value:(_vm.pageNumber),callback:function ($$v) {_vm.pageNumber=$$v},expression:"pageNumber"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }